<template style="z-index: 99999999;">
      <div style="padding: .24rem;z-index: 999999;">
        <titleHead title="委托拍卖合同" @backEvent="backEvent" v-if="$local.get('appOs') != '1'" :fixed="true" :isOther="true"></titleHead>
        <header class="t-head">
          <!--<div class="text-center margin-bottom-md">委托拍卖合同</div>-->
          <div class="box">
            <div class="box-flex">委托人姓名：{{realName}}</div>
          </div>
          <div class="box">
            <div class="box-flex">ID：{{userID}}</div>
          </div>
          <div class="box">
            <p class="box-flex">证件类型：{{certTypeName}}</p>
          </div>
          <div class="box">
            <p class="box-flex">拍卖人：中威网</p>
          </div>
          <div class="box">
            证件号码：{{idNumber}}
          </div>
        </header>
        <div class="pre-wrap" style="line-height: .46rem;z-index: 99999;">
          <b style="z-index: 99999;">   委托人与拍卖人就委托拍卖合同第七条所列拍卖标的之相关事宜，订立合同如下：</b>
          一、委托人就下列拍卖标的不可撤销地向拍卖人保证：自己对所委托拍卖标的拥有绝对的所有权或享有合法处分权，对该拍卖标的拍卖不会侵害任何第三方的合法权益（包括著作权权益），亦不违反相关法律、法规的规定；自己已尽其所知，就该拍卖品的来源和瑕疵向拍卖人进行了全面、详尽的披露和说明，不存在任何隐瞒或虚构之处。如违反上述保证，致使拍卖人蒙受损失时，委托人应负责赔偿拍卖人因此所遭受的一切损失并承担拍卖人因此产生的一切费用（包括但不限于诉讼费、保全费、律师费等）和支出。
          二、委托人授权拍卖人对拍卖标的进行与拍卖有关的各种形式的展示，并印刷、制作拍卖图录及各类宣传品。
          三、委托人在拍卖日前任何时间，向拍卖人发出书面通知说明理由并自愿支付下列各项费用及违约金的，经拍卖人同意后，可撤回其拍卖标的。撤回拍卖标的时，若该拍卖标的已列入的图录或其他宣传品已开始印刷，则应支付相当于该拍卖品金额<b>百分之二十</b>的款项作为违约金并支付其他各项费用。如图录或任何其他宣传品尚未印刷，也需支付相当于该拍卖品金额<b>百分之十</b>的款项作为违约金并支付其他各项费用。如委托人未能向拍卖人支付相应的费用并承担违约金的，则拍卖人有权将委托拍卖标的仍按本合同进行拍卖，委托人无权撤回。
          四、委托人保证自己不参与同时也不委托他人代为参加竞买自己委托的拍卖标的；如其违反本保证，委托人应自行承担相应之法律责任，并赔偿因此给拍卖人造成的全部损失。
          五、除委托人另有书面指示外，在委托人与拍卖人订立本合同并将拍卖标的交付拍卖人后，所有拍卖标的将自动受保于拍卖人的保险，保险金额以保留价为准（无保留价的，以该拍卖标的约定金额为准；调整拍卖保留价的以该拍卖标的原保留价为准）。凡属因拍卖人为拍卖标的所购保险承保范围内的事件或灾害所导致的拍卖标的毁损、灭失，应根据中华人民共和国有关保险的法律和规定处理。拍卖人在向保险公司进行理赔并获得保险赔偿后，将保险赔偿款扣除拍卖人费用（佣金除外）的余款支付给委托人。
          <b style="z-index: 99999;">六、图录费收取标准：整页人民币3000元；1/2页人民币1800元；1/3页人民币1200元；1/4页人民币800元。</b>
          七、委托拍卖标的是指本合同网签时的送拍标的。
          八、拍卖成交时，委托人同意向拍卖人支付成交价的5%作为佣金支付给拍卖人。
          九、拍卖人认为需要对本合同第七条所列拍卖标的进行鉴定的，可以进行鉴定。鉴定结论与本合同载明的状况不符的，拍卖人有权变更或解除本合同。
          <b style="z-index: 99999;">十、特别约定：根据政府税务规定，拍卖人将代扣委托人应缴纳之税费（个人所得税＝落槌价*3%）。</b>
          十一、本合同自签署之日起至拍卖会结束之日起60天内有效，委托人应自收到拍卖人领取通知之日起七日内自负费用取回该拍卖标的，并向拍卖人支付未拍出手续费及其他各项费用，超过上述期限，拍卖人对拍卖标的损坏、遗失不负任何责任，并有权按拍卖规则之规定处理。
          十二、本合同附件为不可分割的同一整体，由双方签署，具有同等法律效力。
          十三、本合同未约定事宜，委托人与拍卖人按照本网站《拍卖规则》的相关条款执行。《拍卖规则》详见本网站的拍卖指南中所述部分，为本合同之组成部分。
          十四、本合同有关任何争议，相关各方均有权向<b>拍卖人住所地人民法院</b>提起诉讼。解决该等争议适用中华人民共和国法律。
          十五、本合同为网签合同，点击同意即为签署本合同并即时生效。

        </div>
      </div>
</template>

<script>
    import popup from '@/components/text/mixin/popup'
    import titleHead from '@/components/common/Title/Thead.vue'
    export default {
        name: "commissionAuctionContract",
        mixins:[popup],
        components: {
            titleHead
          },
      mounted(){
        let post = {
          title : '委托拍卖合同',
          mark : '3.0'
        }
        try{
          window.webkit.setTitle(JSON.stringify(post));
        }catch(e){
        }
        try{
          window.webkit.messageHandlers.setTitle.postMessage(JSON.stringify(post));
        }catch(e){
        }
      }
    }
</script>

<style scoped lang="less">
.t-head {
  font-size: .3rem;
  font-weight: bold;
  .box {
    margin-bottom: .2rem;
    
  }
}
</style>



// WEBPACK FOOTER //
// src/components/text/commissionAuctionContract.vue